import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon, ShieldIcon } from 'lucide-react';
import { SEO } from '../../components/SEO';
export const RamenTintingPage = () => {
  return <main data-id="element-1237" data-mp="27g6mw98j8bk3">
      <SEO title="Ramen Tinten Almere | XPEL Raamfolie | BKCustoms" description="Professionele ramen tinting in Almere vanaf €175. Privacy en UV-bescherming met XPEL premium raamfolie. Hoogwaardige tinting voor optimaal comfort bij BKCustoms." canonical="/diensten/ramen-tinting" data-id="element-1238" data-mp="27evkoduqjbv3" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-28" data-id="element-1239" data-mp="19u9dr2g1likt">
        <div className="absolute inset-0 overflow-hidden" data-id="element-1240" data-mp="1nsz7q97kf24y">
          <div className="absolute inset-0 bg-black/80 z-10" data-id="element-1241" data-mp="1jqcattw1er0w"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wNLF8ocqa3iPQaSqTR3jq1/carwindowtintingfranklintn-768x512.jpg" alt="Ramen Tinting Almere" className="w-full h-full object-cover object-center" data-id="element-1242" data-mp="1jp187xebvpbd" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-1243" data-mp="3q5zsekl09brd">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-1244" data-mp="3v5mdthazlyb9">
            <span className="text-[#D6281F]" data-id="element-1245" data-mp="32brrdqqf48u">Ramen Tinten Almere</span> -
            Privacy met stijl
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1246" data-mp="81y7btu18wkt">
            Professionele ramen tinting in Almere voor privacy en UV-bescherming
            met stijl. Hoogwaardige tinting voor een luxe uitstraling en
            optimaal comfort.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8" data-id="element-1247" data-mp="3bg2c0qtbhqcq">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-1248" data-mp="3gfokkmy7aif7">
              <span className="mr-2" data-id="element-1249" data-mp="2sr5d29mz69o6">Direct afspraak maken</span>
              <ArrowRightIcon size={16} data-id="element-1250" data-mp="2spaswxjj2ll5" />
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-1251" data-mp="3w19si2vdb6gk">
              Offerte aanvragen
            </Link>
          </div>
        </div>
      </div>
      {/* Service Description Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-1252" data-mp="3d4qht94x1ahw">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1253" data-mp="3d5jmm4kbdpxe">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-1254" data-mp="385x9rw8eebp4">
            {/* Image Section */}
            <div className="w-full lg:w-1/2" data-id="element-1255" data-mp="3m5omltn6hm1j">
              <div className="relative" data-id="element-1256" data-mp="3h4shjcr3btuj">
                <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-1257" data-mp="3h3qxiis3jx0o"></div>
                <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-1258" data-mp="wfbgctuc3he3">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wNLF8ocqa3iPQaSqTR3jq1/carwindowtintingfranklintn-768x512.jpg" alt="Ramen tinten voorbeeld in Almere" className="w-full h-auto object-cover" data-id="element-1259" data-mp="14vk9ysa9h5d6" />
                </div>
              </div>
            </div>
            {/* Content Section */}
            <div className="w-full lg:w-1/2" data-id="element-1260" data-mp="1nmtjv2ny1w5a">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1261" data-mp="1nn3beuon0bd3">
                Premium Ramen Tinten in Almere
              </h2>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-1262" data-mp="1dwrtu5c163nq">
                Bij BKCustoms in Almere bieden we professionele ramen tinting
                diensten met hoogwaardige folies die niet alleen uw privacy
                verhogen, maar ook bescherming bieden tegen schadelijke
                UV-stralen en hitte.
              </p>
              <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-1263" data-mp="2bdqkhjaah718">
                Onze ervaren specialisten in Almere zorgen voor een perfecte
                installatie zonder luchtbellen of oneffenheden, voor een
                naadloze en duurzame afwerking die jarenlang mooi blijft.
              </p>
              <div className="space-y-4 mb-8" data-id="element-1264" data-mp="dpwrp6sju0wx">
                <div className="flex items-center" data-id="element-1265" data-mp="8r3ap4e1zrs0">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1266" data-mp="8so7z1rr5otk">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1267" data-mp="16d0rmxcsbp1u" />
                  </div>
                  <span className="text-white/90" data-id="element-1268" data-mp="11gk1xypxt2mn">Tot 99% UV-bescherming</span>
                </div>
                <div className="flex items-center" data-id="element-1269" data-mp="wn7qyre6kucd">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1270" data-mp="rpfm6wsftdqr">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1271" data-mp="rnbm6pxnsyvr" />
                  </div>
                  <span className="text-white/90" data-id="element-1272" data-mp="1p64o0qhe0g05">
                    Vermindert hitte in het interieur
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1273" data-mp="1rprgo0auwgbn">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1274" data-mp="1rrcdxxok2dd7">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1275" data-mp="1wp45gqlafxgv" />
                  </div>
                  <span className="text-white/90" data-id="element-1276" data-mp="21mmfkkb1kiqg">
                    Verhoogde privacy en veiligheid
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1277" data-mp="2ao3tbw0z88bz">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1278" data-mp="2anc9tjknm122">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1279" data-mp="2fmf366r9uiu7" />
                  </div>
                  <span className="text-white/90" data-id="element-1280" data-mp="2kddmzgbgxz27">
                    Verschillende tinten beschikbaar
                  </span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-1281" data-mp="2peujkzmx6zcz">
                <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-1282" data-mp="2udo070xi76hd">
                  <span className="mr-2" data-id="element-1283" data-mp="uamsnwxeuw5i">Afspraak maken</span>
                  <ArrowRightIcon size={16} data-id="element-1284" data-mp="u80ma0m9amov" />
                </Link>
                <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-1285" data-mp="182t6hcd3cr1s">
                  Offerte aanvragen
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Benefits Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-1286" data-mp="1myseyo444t7g">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1287" data-mp="1mz0pwagodog0">
          <div className="text-center mb-16" data-id="element-1288" data-mp="3sqxpzxjnopvk">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1289" data-mp="3srr27e1dw7l3">
              De <span className="text-[#D6281F]" data-id="element-1290" data-mp="3or74o9cwf1yf">Voordelen</span> van Ramen
              Tinten in Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1291" data-mp="3emqpli78tovo">
              Ontdek waarom steeds meer autoliefhebbers in Almere kiezen voor
              ramen tinting.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1292" data-mp="34u1h8w6zor4k">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1293" data-mp="39tntb2b301bs">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-1294" data-mp="2uwwqsk6429hy">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-1295" data-mp="2zxkk5chtb2fc" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1296" data-mp="2lxjhpslwfmxr">
                UV Bescherming
              </h3>
              <p className="text-white/80" data-id="element-1297" data-mp="2qvl00bbi3i86">
                Onze premium folies blokkeren tot 99% van de schadelijke
                UV-stralen, wat uw huid beschermt en het interieur van uw auto
                behoedt voor verkleuring.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1298" data-mp="1xpfc5221zquz">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-1299" data-mp="1xrjdbc8kibrk">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-1300" data-mp="1sr43uvrepoev" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1301" data-mp="1nyax62cdo605">
                Hittereductie
              </h3>
              <p className="text-white/80" data-id="element-1302" data-mp="1jxs6ibm815zj">
                Verminder de binnentemperatuur van uw auto aanzienlijk, wat
                resulteert in minder gebruik van de airconditioning en een
                comfortabelere rijervaring.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1303" data-mp="151t2bc28fpzo">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-1304" data-mp="10zxzu48kf6kb">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-1305" data-mp="2zeispjte6h2b" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1306" data-mp="2vd7cg4wer86s">
                Verhoogde Privacy
              </h3>
              <p className="text-white/80" data-id="element-1307" data-mp="h5y1w7f75zmp">
                Bescherm uw persoonlijke bezittingen tegen nieuwsgierige blikken
                en geniet van meer privacy tijdens het rijden zonder het zicht
                naar buiten te belemmeren.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1308" data-mp="uwtcpp99aqsx">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-1309" data-mp="uyxdvzfrtbpi">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-1310" data-mp="3udsqdvznyfnz" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1311" data-mp="36g8tfuvc07j">
                Verbeterde Look
              </h3>
              <p className="text-white/80" data-id="element-1312" data-mp="75xfudpy15et">
                Getinte ramen geven uw auto een elegante, premium uitstraling
                die het totale uiterlijk van uw voertuig verbetert en de waarde
                kan verhogen.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* XPEL Premium Materials Section */}
      <section className="bg-[#0a0a0a] py-20 border-t border-[#222]" data-id="element-1313" data-mp="s47l4agllpmv">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1314" data-mp="x2ivqnepw465">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-1315" data-mp="x0xzmtcr8d66">
            <div className="w-full lg:w-1/2" data-id="element-1316" data-mp="11uack682mvj3">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1317" data-mp="11vlfy4xlu19o">
                XPEL Premium <span className="text-[#D6281F]" data-id="element-1318" data-mp="16uewy7c3oael">Kwaliteit</span>{' '}
                in Almere
              </h2>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-1319" data-mp="e3n1xd6rtrsu">
                Bij BKCustoms in Almere gebruiken we uitsluitend XPEL raamfolie
                voor al onze tinting diensten. XPEL staat wereldwijd bekend als
                een van de meest hoogwaardige en duurzame merken in de
                automotive industrie.
              </p>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-1320" data-mp="1uhd5mitzae1y">
                XPEL raamfolie biedt superieure helderheid, warmteafwijzing en
                UV-bescherming, zonder verkleuring of bubbels na verloop van
                tijd. Met XPEL bent u verzekerd van een langdurige, hoogwaardige
                afwerking die voldoet aan de strengste kwaliteitseisen.
              </p>
              <div className="space-y-4 mb-8" data-id="element-1321" data-mp="3a7nwn55nafhm">
                <div className="flex items-center" data-id="element-1322" data-mp="35advwtct2heh">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1323" data-mp="359ma2a90fy1e">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1324" data-mp="30c3zygj9bcrt" />
                  </div>
                  <span className="text-white/90" data-id="element-1325" data-mp="2vbomzq2w07ad">
                    Superieure optische helderheid
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1326" data-mp="2rch0i0a38h1e">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1327" data-mp="2mcbf31uevqrr">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1328" data-mp="piq1p5p6f2zd" />
                  </div>
                  <span className="text-white/90" data-id="element-1329" data-mp="kk6e70uxpj4w">
                    Verkleurt niet na verloop van tijd
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1330" data-mp="13myuenz31cec">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1331" data-mp="18f03y24v8p0o">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1332" data-mp="18h32jak33qh0" />
                  </div>
                  <span className="text-white/90" data-id="element-1333" data-mp="ulqy2bg4mlmw">
                    Uitstekende warmtereductie
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1334" data-mp="1nc96zt3j7h88">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1335" data-mp="1naejq84sfd0z">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1336" data-mp="1rdkp7dk2t06e" />
                  </div>
                  <span className="text-white/90" data-id="element-1337" data-mp="1ddjopz7q3urg">
                    Levenslange fabrieksgarantie
                  </span>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/2" data-id="element-1338" data-mp="1y4sixnc96xe">
              <div className="relative" data-id="element-1339" data-mp="2191e8br0que">
                <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-1340" data-mp="6yj2wmcewsyl"></div>
                <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl bg-[#0f0f0f] p-8" data-id="element-1341" data-mp="3vib5ky5v60ff">
                  <div className="text-center" data-id="element-1342" data-mp="8fg1jzgu521b">
                    <div className="mb-6 inline-block" data-id="element-1343" data-mp="8e4zq56ya4cu">
                      <div className="bg-white/5 p-6 rounded-full" data-id="element-1344" data-mp="3gl9e6wza14j">
                        <ShieldIcon size={64} className="text-[#D6281F]" data-id="element-1345" data-mp="3e8u61ilu4v6" />
                      </div>
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-4" data-id="element-1346" data-mp="37ujnfdxn6t68">
                      XPEL Certified Installer in Almere
                    </h3>
                    <p className="text-white/80" data-id="element-1347" data-mp="3lnj59mkwczgy">
                      Als gecertificeerde XPEL installateur in Almere garanderen
                      wij een perfecte installatie volgens de hoogste
                      standaarden in de industrie.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Pricing Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-1348" data-mp="31rgew6zmb3hs">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1349" data-mp="36tflrqukgijh">
          <div className="text-center mb-16" data-id="element-1350" data-mp="3brh3o8g9abtd">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1351" data-mp="3bqfopsw4d56d">
              Onze <span className="text-[#D6281F]" data-id="element-1352" data-mp="3gifkra92jdxo">Prijzen</span> voor Ramen
              Tinten in Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1353" data-mp="3kizh4bltidir">
              Transparante prijzen voor ramen tinting in Almere op basis van
              autotype
            </p>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#222] bg-[#0f0f0f] shadow-lg" data-id="element-1354" data-mp="3uj9xg535g125">
            <div className="overflow-x-auto" data-id="element-1355" data-mp="3ack5w0azwm9">
              <table className="w-full text-white" data-id="element-1356" data-mp="203xjio8pejvn">
                <thead data-id="element-1357" data-mp="2058x1fryb5zy">
                  <tr className="bg-[#0a0a0a]" data-id="element-1358" data-mp="2060jo13klte3">
                    <th className="px-6 py-4 text-left font-semibold" data-id="element-1359" data-mp="2528tcyz00udv">
                      Type Auto
                    </th>
                    <th className="px-6 py-4 text-right font-semibold" data-id="element-1360" data-mp="m9h266o2afan">
                      Prijs
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[#222]" data-id="element-1361" data-mp="desy2ju833nf">
                  <tr className="hover:bg-[#0a0a0a]/60 transition-colors" data-id="element-1362" data-mp="dd81yps9fcng">
                    <td className="px-6 py-4" data-id="element-1363" data-mp="8i2g1qyuxxzd">Hatchback 3 deurs</td>
                    <td className="px-6 py-4 text-right text-[#D6281F] font-semibold" data-id="element-1364" data-mp="1571p3879n3sm">
                      €175
                    </td>
                  </tr>
                  <tr className="hover:bg-[#0a0a0a]/60 transition-colors" data-id="element-1365" data-mp="w63lus4nj0b3">
                    <td className="px-6 py-4" data-id="element-1366" data-mp="w4923h549e8l">Hatchback 5 deurs</td>
                    <td className="px-6 py-4 text-right text-[#D6281F] font-semibold" data-id="element-1367" data-mp="r5xrv5awt1pu">
                      €225
                    </td>
                  </tr>
                  <tr className="hover:bg-[#0a0a0a]/60 transition-colors" data-id="element-1368" data-mp="3bx8197xxg6ge">
                    <td className="px-6 py-4" data-id="element-1369" data-mp="3bzb08hh259x9">Coupe</td>
                    <td className="px-6 py-4 text-right text-[#D6281F] font-semibold" data-id="element-1370" data-mp="3dfgd1bhoqzmw">
                      €225
                    </td>
                  </tr>
                  <tr className="hover:bg-[#0a0a0a]/60 transition-colors" data-id="element-1371" data-mp="34dp7q7r24utk">
                    <td className="px-6 py-4" data-id="element-1372" data-mp="34ftb8ol1nrtb">Sedan</td>
                    <td className="px-6 py-4 text-right text-[#D6281F] font-semibold" data-id="element-1373" data-mp="39c0g0e1pex9o">
                      €250
                    </td>
                  </tr>
                  <tr className="hover:bg-[#0a0a0a]/60 transition-colors" data-id="element-1374" data-mp="2zem2onb2uoll">
                    <td className="px-6 py-4" data-id="element-1375" data-mp="2zfx78pcck0dr">SUV</td>
                    <td className="px-6 py-4 text-right text-[#D6281F] font-semibold" data-id="element-1376" data-mp="2lo0i8u5z66ll">
                      €280
                    </td>
                  </tr>
                  <tr className="hover:bg-[#0a0a0a]/60 transition-colors" data-id="element-1377" data-mp="2pmgapdkts76e">
                    <td className="px-6 py-4" data-id="element-1378" data-mp="2bptexe4lzn22">Station</td>
                    <td className="px-6 py-4 text-right text-[#D6281F] font-semibold" data-id="element-1379" data-mp="2goe48iibombq">
                      €280
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="mt-8 text-center" data-id="element-1380" data-mp="1s4sykhln9z3y">
            <p className="text-white/70 text-sm" data-id="element-1381" data-mp="2708w4wlfod53">
              * Alle prijzen zijn inclusief BTW en professionele installatie in
              Almere.
              <br data-id="element-1382" data-mp="21zunpdfx716j" />* Prijzen kunnen variëren afhankelijk van specifieke
              aanpassingen of extra wensen.
            </p>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-[#0a0a0a] py-16 border-t border-[#222]" data-id="element-1383" data-mp="2b1u2dz3gpt6b">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-1384" data-mp="2ppymn7i5ycr7">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-1385" data-mp="2ks6x2k4zr2q6">
            Klaar voor meer comfort en stijl met ramen tinten in Almere?
          </h2>
          <p className="text-white/80 mb-8" data-id="element-1386" data-mp="2ys7vlsxs9y2h">
            Neem contact met ons op voor een persoonlijk advies of maak direct
            een afspraak voor jouw auto bij BKCustoms in Almere.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1387" data-mp="4z54hk4fvca2">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide" data-id="element-1388" data-mp="9xoq1jf4em1w">
              Afspraak maken
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10" data-id="element-1389" data-mp="3iejehtv683wg">
              Contact opnemen
            </Link>
          </div>
        </div>
      </section>
    </main>;
};